import { createSlice } from "@reduxjs/toolkit"

const initialState: { value: boolean } = { value: false }

const headerPinSlice = createSlice({
  name: "header_pin_slice",
  initialState,
  reducers: {
    pin: (state) => {
      state.value = true
    },
    unpin: (state) => {
      state.value = false
    }
  }
})

export const { pin, unpin } = headerPinSlice.actions
export const header_pin_slice = headerPinSlice.reducer